(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    // Handle accordion toggle button clicks
  document.addEventListener('DOMContentLoaded', () => {
    const toggleButtons = document.querySelectorAll('.menu-drawer__accordion-toggle');
    
    toggleButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Find the parent details element
        const details = button.closest('details');
        if (details) {
          details.open = !details.open;
        }
      });
    });

    // Prevent summary default behavior when clicking inside
    const summaries = document.querySelectorAll('.menu-drawer__menu-item--with-link');
    summaries.forEach(summary => {
      summary.addEventListener('click', (e) => {
        // Only prevent default if clicking on the link (not the button)
        if (e.target.closest('.menu-drawer__parent-link')) {
          e.stopPropagation();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
